import { Box, Button, Typography } from "@mui/material";
import { ROUTES_DASHBOARD } from "commons/constants/paths";
import { useAppDispatch } from "commons/store/hooks";
import TextFieldFormik from "components/Form/TextFieldFormik";
import { loginAlternative } from "core/redux/userSlice";
import { Form, Formik } from "formik";
import { useSnackbar} from "notistack";
import { Navigate, useNavigate } from "react-router-dom";
import ColoredBox from "components/ColoredBox";
import yup from "commons/yup";
import { Link } from "react-router-dom";
import { ROUTES_CORE } from "commons/constants/paths";
import { getToken, isTokenExpired } from "commons/auth/tokens";
import { PROJECT_NAME, USER_REGISTER } from "commons/constants/env";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const validationSchema = yup.object({
  token: yup.string().required(),
});

const LoginAlternative = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const token = getToken();
  const { t } = useTranslation();

  const [isTokenVisible, setTokenVisible] = useState(false)
  const [isProcessing, setProcessing] = useState(false)

  const initialValues = {
    token: '',
  };

  const handleSubmit = async (values: typeof initialValues) => {
    setProcessing(true);

    try {
      await dispatch(loginAlternative(values));
      navigate(ROUTES_DASHBOARD.DASHBOARD);
    } catch (error: any) {
      enqueueSnackbar(t('invalid-data-entered-please-re-enter-the-correct-details'), {
        variant: 'error',
      });
    }

    setProcessing(false);
  };

  if (token && !isTokenExpired(token)) {
    return <Navigate to={ROUTES_DASHBOARD.DASHBOARD}/>;
  }

  return (
    <Box
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      pl={2}
      pr={2}
    >
      <ColoredBox p={5} width={352} maxWidth="100%">
        <Typography variant="body2">{PROJECT_NAME}</Typography>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Typography variant="h5">{t('login')}</Typography>

            <Box mt={3.5}>
              <TextFieldFormik
                margin="dense"
                name="token"
                label={t('Token')}
                type={isTokenVisible ? 'text' : 'password'}
                variant="outlined"
                fullWidth
              />
              <Button size={"small"} onClick={() => setTokenVisible(!isTokenVisible)} color={'primary'}>
                {isTokenVisible ? t('hide-token') : t('show-token')}
              </Button>
            </Box>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Box>
                <Button type="submit" color="primary" variant="contained" disabled={isProcessing}>
                  {t('log-in')}
                </Button>
              </Box>
            </Box>
            <Box mt={1.5} display="flex" justifyContent="flex-end">
              <Button
                color="primary"
                component={Link}
                to={ROUTES_CORE.FORGOT_PASSWORD}
                sx={{ textTransform: 'unset' }}
              >
                {t('change-password')}
              </Button>
              {USER_REGISTER &&
                <Button
                  color="primary"
                  component={Link}
                  to={ROUTES_CORE.REGISTER}
                  sx={{ textTransform: 'unset' }}
                >
                  {t('Registration')}
                </Button>
              }
            </Box>
          </Form>
        </Formik>
      </ColoredBox>
    </Box>
  );
};

export default LoginAlternative;
